import React from 'react';
import { highlightSearchMatch } from '../../../../utils/search';
export const SearchedText = ({ text, search }) => {
    const parts = highlightSearchMatch(text, search);
    return (React.createElement(React.Fragment, null, parts.map((part, index) => part.isBold ? React.createElement("strong", { key: index }, part.text) : part.text)));
};
